/*
 *
 * PayByLinkFirstActivationPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 27-Mar-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  firstActivationPopupTitle: <PortalMessage id='t.app.services.payByLink.popup.firstActivation.title' defaultMessage='Perchè usare Pay-By-Link?' />,
  firstActivationPopupCopy: <PortalMessage id='t.app.services.payByLink.popup.firstActivation.copy' defaultMessage='Con il servizio Pay-By-Link puoi aumentare i tuoi incassi:' />,
  firstActivationPopupCopyFirstPoint: <PortalMessage id='t.app.services.payByLink.popup.firstActivation.copy.first' defaultMessage='Consegnando a domicilio senza avere applicazioni come Glovo;' />,
  firstActivationPopupCopySecondPoint: <PortalMessage id='t.app.services.payByLink.popup.firstActivation.copy.second' defaultMessage='Emettendo una richiesta di anticipo/ cauzione prima di erogare il servizio/ prenotazione;' />,
  firstActivationPopupCopyThirdPoint: <PortalMessage id='t.app.services.payByLink.popup.firstActivation.copy.third' defaultMessage='Richiedendo pagamenti di fatture arretrate il servizio PAY-BY-LINK è incluso nel tuo contratto di convenzionamento e non prevede canoni aggiuntivi/ costi di attivazione.' />,
  firstActivationPopupButtonLabel: <PortalMessage id='t.app.services.payByLink.popup.firstActivation.buttonLabel' defaultMessage='Incassa ora' />
}

export default formattedMessage
